import React from 'react';
import './CheckinCheckout.css';

const CheckinCheckout = ({
    showTimer,
    elapsedTime,
    isBreak,
    formatTime,
    handleCheckin,
    handleToggleBreak,
    handleCheckout,
    canCheckin,
    hasTodayCheckout
}) => {
    return (
        <div className="checkin-checkout-panel">
            {!showTimer ? (
                <button
                    onClick={handleCheckin}
                    disabled={!canCheckin}
                    className={`checkin-button ${!canCheckin ? 'disabled' : ''}`}
                >
                    Check In {hasTodayCheckout && '(Done for Today)'}
                </button>
            ) : (
                <div className="timer-container">
                    <div className="timer-display">
                        {formatTime(elapsedTime)}
                    </div>
                    <div className="action-buttons">
                        <button
                            onClick={handleToggleBreak}
                            className={`toggle-break-button ${isBreak ? 'resume' : 'break'}`}
                        >
                            {isBreak ? 'Resume' : 'Break'}
                        </button>
                        <button
                            onClick={handleCheckout}
                            className="checkout-button"
                        >
                            Checkout
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CheckinCheckout;
